var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0a250 250 0 1 0 0 500 250 250 0 0 0 0-500zm0 475a225 225 0 1 1 0-450 225 225 0 0 1 0 450z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.6 399.3V262.8h45.9l6.8-53.2h-52.7v-34c0-15.4 4.3-26 26.4-26h28.2v-47.5a376.1 376.1 0 0 0-41-2.1c-40.7 0-68.5 24.8-68.5 70.3v39.3h-46v53.2h46v136.5z"
  })));
};
export default SvgFacebookLogo;